<template>
  <div class="form-group flex flex-col">
    <div :class="`flex flex-${align ?? 'col'} gap-2`">
      <label :for="name">{{
        props.label ? t(`labels.${props.label}`) : t(`labels.${props.name}`)
      }}</label>
      <Checkbox
        :id="name"
        v-model="internalValue"
        :disabled="disabled"
        :data-testid="`checkbox-${name}`"
        binary
      />
    </div>
    <FormError v-if="!disabled" :message="errorMessage" />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import { useField } from 'vee-validate';
import { useI18n } from 'vue-i18n';

import FormError from './errors/FormError.vue';

const props = defineProps<{
  name: string;
  modelValue: boolean | undefined;
  initialValue: boolean | undefined;
  isDirty: (dirty: boolean) => void;
  label?: string;
  disabled?: boolean;
  align?: 'col' | 'row';
}>();

const { t } = useI18n();
const { errorMessage } = useField<boolean>(props.name);

const internalValue = ref(props.modelValue ?? false);
const initialValue = computed(() => props.initialValue);

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

watch(
  internalValue,
  (newValue) => {
    emit('update:modelValue', newValue);
  },
  { immediate: true },
);

watch([internalValue, initialValue], () => {
  props.isDirty(internalValue.value !== initialValue.value);
});

watch(
  () => props.modelValue,
  (newValue) => {
    internalValue.value = newValue ?? false;
  },
);
</script>
